import { z } from "zod";
import { TOURNAMENT_BRACKET_SIZES, TOURNAMENT_SEEDING_RULES } from "../types/tournament.js";

const bracketSize = z
  .number()
  .int()
  .refine((n) => (TOURNAMENT_BRACKET_SIZES as readonly number[]).includes(n), {
    message: "Bracket size must be 4, 8, 16, or 32",
  });

// Create a draft bracket for a tournament event.
export const createTournamentSchema = z.object({
  bracket_size: bracketSize,
  seeding_rule: z.enum(TOURNAMENT_SEEDING_RULES).default("manual"),
});

// Update bracket shape while still in draft.
export const updateTournamentSchema = z.object({
  bracket_size: bracketSize.optional(),
  seeding_rule: z.enum(TOURNAMENT_SEEDING_RULES).optional(),
});

// One manual seed assignment: which team holds seed `slot` (1 = top seed).
const seedAssignment = z.object({
  slot: z.number().int().min(1, "Seed must be 1 or greater"),
  team_id: z.string().min(1, "Team is required"),
});

// Publish a draft bracket. Manual seeding supplies `seeds`; random omits it and
// the server assigns. Seeding is folded into publish (no separate draft store).
export const publishTournamentSchema = z.object({
  seeds: z.array(seedAssignment).optional(),
});

export type CreateTournamentInput = z.infer<typeof createTournamentSchema>;
export type UpdateTournamentInput = z.infer<typeof updateTournamentSchema>;
export type PublishTournamentInput = z.infer<typeof publishTournamentSchema>;
